import React, { useEffect, useRef, useState } from "react";

/** Common Components */
import Buttons from "../../../../components/ui/button/Buttons";
import FormCreator from "../../../../components/forms/FormCreator";

/** Configuration Files */
import { addEditClientPlansFormConfig } from "./addEditClientPlans.formfields.config";
import { useAddClientPlanMutation, useGetClientPlanListByIdMutation, useUpdateClientPlanMutation } from "../../../../app/services/clientPlanAPI";
import ToastService from "../../../../services/toastService/ToastService";
import PropTypes from "prop-types";

const AddEditClientPlans = (props) => {
  const clientRef = useRef(null);

  const [clientPlanForm, setClientPlanForm] = useState(addEditClientPlansFormConfig);

  const [addClientPlan, {
    isLoading: isClientPlanAdding,
    isSuccess: isClientPlanAdded,
    data: clientPlanAddedData
  }] = useAddClientPlanMutation()

  const [updateClientPlan, {
    isLoading: isClientPlanUpdating,
    isSuccess: isClientPlanUpdated,
    data: clientPlanUpdatedData,
  }] = useUpdateClientPlanMutation();

  const resetForm = () => {
    const form = { ...addEditClientPlansFormConfig };
    form.initialState = {
      ...addEditClientPlansFormConfig.initialState,
      clientName:props.clientName
    }
    setClientPlanForm(form);
  };


  const handleCloseClick = () => {
    resetForm();
    props?.onClose();
  };

  useEffect(() => {
    if (props.isEdit && props.initData) {
      const form = { ...clientPlanForm };
      form.initialState = {
        ...props.initData,
        clientName:props.clientName
      };
      setClientPlanForm(form);
    } else {
      resetForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isEdit, props.initData]);

  const handleAddUpdateClick = () => {
    const formData = clientRef.current.getFormData();
    if (formData) {
      const req = {
        clientID: props.clientID,
        clientName: props.clientName,
        planName: formData.planName,
        planNumber: formData.planNumber,
        planYearMonth: formData.planYearMonth,
        planYearDay: formData.planYearDay,
        planID: props.isEdit ? props.initData.planID : 0,
      }
      if (props.isEdit) {
        updateClientPlan(req);
      } else {
        addClientPlan(req);
      }
    }
  };

  useEffect(() => {
    if (isClientPlanAdded && clientPlanAddedData) {
      if (clientPlanAddedData?.errorMessage?.includes('exist')) {
        ToastService.warning(clientPlanAddedData.errorMessage);
      } else {
        ToastService.success(clientPlanAddedData.errorMessage);
        props.onSuccess?.();
      }
    }
  }, [isClientPlanAdded, clientPlanAddedData]);

  useEffect(() => {
    if (isClientPlanUpdated && clientPlanUpdatedData) {
      const msg = clientPlanUpdatedData?.errorMessage ?? "";

      if (msg.includes("NO RECORD FOUND") || msg.includes("exist")) {
        ToastService.warning(msg);
      } else {
        ToastService.success(msg);
        props.onSuccess?.();
      }
    }
  }, [isClientPlanUpdated, clientPlanUpdatedData]);

 

  return (
    <>
      <div>
        <FormCreator ref={clientRef} config={clientPlanForm} />
      </div>
      <div className="form-button-group">
        <Buttons
          buttonText="Cancel"
          buttonTypeClassName="btn secondary-btn"
          onClick={handleCloseClick}
        />
        <Buttons
          buttonText={props.isEdit ? "Update" : "Add"}
          buttonTypeClassName="btn blue-btn w-full"
          onClick={handleAddUpdateClick}
          isLoading={false}
          
        />
      </div>
    </>
  );
};

AddEditClientPlans.propTypes = {
  isEdit: PropTypes.bool.isRequired,
  clientID: PropTypes.number.isRequired,
  clientName: PropTypes.string.isRequired,
  initData: PropTypes.shape({
    planID: PropTypes.number,
    planName: PropTypes.string,
    planNumber: PropTypes.string,
    planYearMonth: PropTypes.string,
    planYearDay: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
};

export default AddEditClientPlans;
